<template>
<div>
         <v-row justify="center">

      <v-dialog v-model="dialog" persistent max-width="405">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark v-on="on">SİL</v-btn>
        </template>
        <v-card>
          <v-card-title class="headline">Silme işlemi gerçekleştirilsin mi?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="error" text @click="dialog = false">Hayır</v-btn>
            <v-btn type="success" text @click="dialog = false " :to="route">Evet</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
         </v-row>
</div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      route: "/login"
    }
  }
}
</script>